<template>
  <div>
    <h4>{{video_group.name}}</h4>
    <!--Sidebar pre video {{this.id}}-->
    <ol class="video-playlist">
      <li v-for="video in (!!video_group && video_group.videos || [])">
        <router-link
          v-if="video"
          :to="{name: 'video', params:{id: video.id}}"
          class="playlist-item"
        >
          <video-thumb-progress :thumb="video.thumb" value="10" class="playlist-item--thumb" />
          <div class="playlist-item--text">
            <h5>{{video.idx}}. {{video.name}}</h5>
            <div>
              <div class="text-mute duration">{{video.duration}}</div>
              <play-button />
            </div>
          </div>
        </router-link>
      </li>
    </ol>
  </div>
</template>

<style lang="less">
.video-playlist {
  list-style-type: none;
  padding: 0;
  margin: 0;

  li:last-child {
    &.playlist-item {
      border-bottom: none;
    }
  }

  a,
  a:hover,
  a:visited,
  a:link,
  a:active {
    &.playlist-item {
      color: #000000;
      display: flex;
      flex-direction: row;
      text-align: left;
      border-bottom: 1px solid #eeeeee;
      padding: 1rem;

      h5 {
        margin-top: 0;
        width: 100%;
        display: block;
        font-size: 0.875rem;
      }

      .duration {
        float: left;
      }

      .play {
        float: right;
      }

      .playlist-item--thumb {
        flex: 2;
      }
      .playlist-item--text {
        flex: 3;
        margin-left: 10px;
        font-size: 0.875rem;
        font-weight: normal;
      }
    }
  }
}
.play {
  height: 10px;
  width: 10px;
  background: url(../../../../../maxman-template/images/play.png) no-repeat
    center center;
  background-size: contain;
  margin-right: 8px;
  display: inline-block;
}
</style>

<script>
import VideoThumbProgress from "./VideoThumbProgress";
import PlayButton from "./PlayButton";
import util from "../../../app/util/index";

export default {
  components: {
    "video-thumb-progress": VideoThumbProgress,
    "play-button": PlayButton
  },
  data() {
    return {
      model: null,
      video_groups: null
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    video_group() {
      const vg =
        !!this.video_groups &&
        !!this.model &&
        util.findInArray(
          this.video_groups,
          group => group.id == this.model.video_group_id
        );

      if (vg) {
        vg.videos = vg.videos.map(video => ({
          ...video,
          thumb: this.$api.server.prependServerUrl("storage/" + video.thumb)
        }));
      }

      return vg;
    }
  },
  methods: {
    refresh() {
      this.$api.server
        .get(
          "api/public/video-groups/all?lang_id=" +
            this.$api.translator.getCurrent()
        )
        .then(r => {
          this.video_groups = r.data.video_groups;
          return true;
        });

      this.$api.server.get("api/public/video/get?id=" + this.id).then(r => {
        this.model = r.data[0];
        this.model.path = this.$api.server.prependServerUrl(
          "storage/" + this.model.path
        );
        this.model.thumb = this.$api.server.prependServerUrl(
          "storage/" + this.model.thumb
        );
        return true;
      });
    }
  },
  watch: {
    id: {
      handler() {
        this.model = null;
        this.refresh();
      },
      immediate: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/public_app/pages/videozone/VideoSidebar.vue